import React from 'react';
import { Colors } from 'library';
import DownloadTheAppButtons from 'parent-portal/public/shared/components/DownloadTheAppButtons';
import { Card, Icon, Stack, Text, Title } from 'library/ui';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

export default function TeacherDownloadCard() {
    return (
        <Card grow>
            <Stack align="center">
                <Icon size="lg" icon={PhoneIphoneIcon} bgColor={Colors.secondary} iconColor={Colors.white} />
                <Title size="h2">Get the Tandem App</Title>
                <Text size="sm" tone="secondary">
                    Teachers create their accounts through the Tandem mobile app. Download it now to get started.
                </Text>
                <DownloadTheAppButtons />
            </Stack>
        </Card>
    );
}
